import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/clipboard-edit.vue
var o = {
	name: "DtIconClipboardEdit",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--clipboard-edit"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Clipboard Edit",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M5.953 6.497a.55.55 0 0 0-.39.161L2.947 9.28l-.258 1.03 1.031-.261 2.622-2.613a.552.552 0 0 0-.178-.897.55.55 0 0 0-.21-.042Zm-.594-.882a1.55 1.55 0 0 1 1.69 2.529l-2.721 2.71a.5.5 0 0 1-.23.13l-1.975.5a.5.5 0 0 1-.608-.606l.495-1.975a.5.5 0 0 1 .131-.231l2.715-2.72c.144-.144.315-.259.503-.337Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M3.5 1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1H9A1.5 1.5 0 0 1 10.5 3v7A1.5 1.5 0 0 1 9 11.5H6.25a.5.5 0 0 1 0-1H9a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5h-.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 1-1 0V3A1.5 1.5 0 0 1 3 1.5h.5Zm1 0h3v1h-3v-1Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=clipboard-edit.js.map